module.exports = __webpack_public_path__ + "img/kiss.2df09483.svg";